// src/components/Dashboard/RoleDashboard/VSNTransfersAdapter.js
import React from "react";
import VSNTransfers from "./VSNTransfers"; // ✅ same folder import

export default function VSNTransfersAdapter(props) {
    const { role, userId, id, agentId, scoutId, clubId } = props;

    // ✅ Resolve a single effective ID no matter the role
    const effectiveId =
        userId ?? id ?? agentId ?? scoutId ?? clubId;

    if (!effectiveId) {
        console.error(
            "[VSNTransfersAdapter] Missing user id for role:",
            role,
            props
        );
        return null;
    }

    return (
        <VSNTransfers
            role={role}
            userId={effectiveId}
            {...props}
        />
    );
}


